type ElapsedHour = (start: Date, end: Date) => number;

export const elapsedHour: ElapsedHour = (start, end) => {
  if (start > end) return 0;

  return Math.floor((end.getTime() - start.getTime()) / (1000 * 60 * 60));
};
